import React from "react";

const Icon_1 = () => {
  return (
    <>
      <svg
        width="232"
        height="125"
        viewBox="0 0 232 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_i_3221_22537)">
          <rect
            x="124"
            y="17.8571"
            width="45.1681"
            height="107.143"
            rx="7.38889"
            fill="url(#paint0_linear_3221_22537)"
          />
        </g>
        <g filter="url(#filter1_i_3221_22537)">
          <rect
            x="185.977"
            width="45.1681"
            height="125"
            rx="7.38889"
            fill="url(#paint1_linear_3221_22537)"
          />
        </g>
        <g filter="url(#filter2_i_3221_22537)">
          <rect
            x="62.0273"
            y="8.4032"
            width="45.1681"
            height="116.597"
            rx="7.38889"
            fill="url(#paint2_linear_3221_22537)"
          />
        </g>
        <g filter="url(#filter3_i_3221_22537)">
          <rect
            x="0.0507812"
            y="46.2184"
            width="45.1681"
            height="78.7815"
            rx="7.38889"
            fill="url(#paint3_linear_3221_22537)"
          />
        </g>
        <defs>
          <filter
            id="filter0_i_3221_22537"
            x="124"
            y="17.8571"
            width="45.168"
            height="108.067"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.84722" />
            <feGaussianBlur stdDeviation="0.461806" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.811765 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_3221_22537"
            />
          </filter>
          <filter
            id="filter1_i_3221_22537"
            x="185.977"
            y="0"
            width="45.168"
            height="125.924"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.84722" />
            <feGaussianBlur stdDeviation="0.461806" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.811765 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_3221_22537"
            />
          </filter>
          <filter
            id="filter2_i_3221_22537"
            x="62.0273"
            y="8.4032"
            width="45.168"
            height="117.52"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.84722" />
            <feGaussianBlur stdDeviation="0.461806" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.811765 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_3221_22537"
            />
          </filter>
          <filter
            id="filter3_i_3221_22537"
            x="0.0507812"
            y="46.2184"
            width="45.168"
            height="79.7051"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1.84722" />
            <feGaussianBlur stdDeviation="0.461806" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.811765 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect1_innerShadow_3221_22537"
            />
          </filter>
          <linearGradient
            id="paint0_linear_3221_22537"
            x1="146.584"
            y1="17.8571"
            x2="146.584"
            y2="125"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0645909" stopColor="#15222D" />
            <stop offset="1" stopColor="#050E19" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3221_22537"
            x1="208.561"
            y1="0"
            x2="208.561"
            y2="125"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0645909" stopColor="#15222D" />
            <stop offset="1" stopColor="#050E19" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3221_22537"
            x1="84.6114"
            y1="8.4032"
            x2="84.6114"
            y2="125"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0645909" stopColor="#15222D" />
            <stop offset="1" stopColor="#050E19" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_3221_22537"
            x1="22.6348"
            y1="46.2184"
            x2="22.6348"
            y2="125"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.0645909" stopColor="#15222D" />
            <stop offset="1" stopColor="#050E19" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export default Icon_1;
